import { ApiUrlHelper } from '../../common/apiUrlHelper';
import { matchValidator } from '../../common/form-validators';
import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { RecoverPassword } from '../../constants/message-constant';
import { ResetPasswordConstant } from 'src/app/constants/label-constants';
import { changePasswordErrorMessage } from 'src/app/constants/error-message-constant';
@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {
  emailId: string = "";
  recoverPasswordForm: FormGroup = this.formBuilder.group({});;
  password: any;
  show = false;
  public isAuthLoading = false;
  submitted = false;
  UserId: any;
  EncryptedURLDateTime: any;
  validPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+*!=]).*$/;
  queryString = Object();
  emailAddress: any;
  IsShowNewPassword: boolean = false;
  IsShowOldPassword: boolean = false;
  resetPasswordConstant: any = [];
  errorMessageForPassword:any=[];

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private toster: ToastrService,
    private apiUrl: ApiUrlHelper,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.resetPasswordConstant = ResetPasswordConstant;
    this.initForm();
    this.onLoad();
    this.errorMessageForPassword=changePasswordErrorMessage;
  }

  onLoad() {
    this.activatedRoute.params.subscribe(parms => {
      this.queryString = parms[''];
      let emailadd = parms[''];
      this.emailAddress = atob(emailadd);
    });
  }

  goLogin(){
    this.router.navigate(['/login'])
  }

  initForm() {
    this.recoverPasswordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/)]]
    });
  }
  get recoverPasswordFormControl() {
    return this.recoverPasswordForm.controls;
  }
  onPaste(event: ClipboardEvent) {
    event.preventDefault(); // Prevent the default paste behavior
  }
  validateResetPassword() {
    this.submitted = true;
    if (!this.recoverPasswordForm.value.newPassword || !this.recoverPasswordForm.value.confirmPassword) {
      return false;
    }
    if (this.recoverPasswordForm.value.newPassword === this.recoverPasswordForm.value.confirmPassword) {
      this.submitted = true;
      this.spinner.show();
      let objData = {
        EmailId: this.emailAddress,
        NewPassword: this.recoverPasswordForm.value.newPassword,
        ConfirmPassword: this.recoverPasswordForm.value.confirmPassword
      };
      if (this.recoverPasswordForm.status == "VALID") {
        const apiUrl = this.apiUrl.apiUrl.forgotPassword.ResetPassword;
        this.commonService.doPut(apiUrl, objData).pipe().subscribe({
          next: async (data) => {
            if (data.success) {
              this.spinner.hide();
              this.router.navigate(['/login']);
              this.toster.success(data.message);
              return true;
            }
            else {
              this.spinner.hide();
              this.toster.error(data.message);
              return false;
            }
          },
          error: (error) => {
            this.toster.error(error.error.message);
            this.spinner.hide();
          }
        });
      }
      else{
        this.spinner.hide();
      }
      return true;
    }
    else {
      this.toster.error(RecoverPassword.Confirm_Password);
      return false;
    }
  }

  showNewPassword() {
    this.IsShowNewPassword = !this.IsShowNewPassword;
  }
  showOldPassword() {
    this.IsShowOldPassword = !this.IsShowOldPassword;
  }
}


